var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20.00106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fc0;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-1,.cls-2{fill:none;}.cls-2{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    className: "cls-2",
    d: "M0,.00004h20v20H0V.00004Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7837"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.24799,2c-3.45068,0-6.24799,2.79736-6.24799,6.24805v.00098c.00055,3.45068,2.79834,6.24756,6.24902,6.24701,3.45062-.00055,6.24756-2.79834,6.24695-6.24902-.00055-3.45026-2.79767-6.24701-6.24799-6.24701Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25313",
    className: "cls-1",
    d: "M17.99898,18.00106l-5.24016-5.24114"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconYellow);
export default __webpack_public_path__ + "static/media/SearchIconYellow.57b9ac81ceefa6b8f64565923bbae390.svg";
export { ForwardRef as ReactComponent };